import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import "./OurCourses.css";

const COURSES = [
  // {
  //   slug: "english-for-adults",
  //   title: "English for Adults",
  //   description:
  //     "A comprehensive English language program designed to help adults improve communication skills for professional and everyday use.",
  //   cover: "/English-Cover.png",
  //   path: "/courses/english-for-adults",
  // },
  {
    slug: "toefl",
    title: "TOEFL Preparation",
    description:
      "Intensive preparation for the Test of English as a Foreign Language with expert strategies to maximize your score.",
    cover: "/TOEFL-Cover.png",
    path: "/courses/toefl",
  },
  // {
  //   slug: "ielts",
  //   title: "IELTS Preparation",
  //   description:
  //     "Expert-guided IELTS preparation covering all four core skills: reading, writing, listening, and speaking.",
  //   cover: "/IELTS-Cover.png",
  //   path: "/courses/ielts",
  // },
  {
    slug: "microsoft-programs",
    title: "Microsoft Programs",
    description:
      "Professional Microsoft Office and digital skills certification programs to enhance your productivity and career prospects.",
    cover: "/Microsoft-programs-Cover.png",
    path: "/courses/microsoft-programs",
  },
  // {
  //   slug: "english-for-kids",
  //   title: "English for Kids",
  //   description:
  //     "Our English for Kids course is specially designed to help young learners build a strong foundation in English through fun, engaging, and interactive learning experiences.",
  //   cover: "/English-kids-cover.png",
  //   path: "/courses/english-for-kids",
  // },
  {
    slug: "tefl",
    title: "TEFL for Foreigners",
    description:
      "Our TEFL Course is designed to equip non-native speakers with the skills, knowledge, and confidence needed to teach English effectively in international settings.",
    cover: "/TEFL-cover.jpg",
    path: "/courses/tefl",
  },
  {
    slug: "hr-course",
    title: "HR Exams",
    description:
      "Our Human Resources (HR) Exams is designed to equip students with the knowledge, practical skills, and confidence needed to succeed in the dynamic field of human resources.",
    cover: "/HR-cover.jpg",
    path: "/courses/hr-course",
  },
  // {
  //   slug: "arabic-for-foreigners",
  //   title: "Arabic for Foreigners",
  //   description:
  //     "Our Arabic for Foreigners course is designed specifically for international learners aiming to equip them with Arabic language skills and confidence for real-life communication.",
  //   cover: "/Arabic-cover.png",
  //   path: "/courses/arabic-for-foreigners",
  // },
];

function OurCourses() {
  const navigate = useNavigate();
  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (slug) => {
    setLoadedImages((prev) => ({ ...prev, [slug]: true }));
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: "mobile",
      throttleDelay: 99,
      debounceDelay: 50,
    });
  }, []);

  return (
    <section className="our-courses-section" id="our-courses">
      <Helmet>
        <meta
          name="description"
          content="Explore Talent Track's language and professional courses: English for Adults, TOEFL, IELTS, and Microsoft Programs."
        />
      </Helmet>
      <Container>
        <div className="our-courses-header text-center">
          <h2 className="our-courses-title">Our Educational Services and Online Courses</h2>
          <p className="our-courses-subtitle">
            Enhance your skills with our professionally designed programs
          </p>
        </div>

        <Row className="justify-content-center g-4">
          {COURSES.map((course, index) => {
            const Icon = course.Icon;
            return (
              <Col
                key={course.slug}
                xs={12}
                sm={6}
                lg={3}
                className="d-flex justify-content-center"
                data-aos="fade-up"
                data-aos-delay={(index % 4) * 120}
              >
                <Card className="oc-card border-0">
                  <div className="oc-card-image-area">
                    {!loadedImages[course.slug] && (
                      <div className="oc-img-skeleton" />
                    )}
                    <img
                      src={course.cover}
                      alt={course.title}
                      className="oc-card-cover-img"
                      loading="lazy"
                      decoding="async"
                      width="400"
                      height="260"
                      onLoad={() => handleImageLoad(course.slug)}
                      style={loadedImages[course.slug] ? {} : { opacity: 0, position: 'absolute' }}
                    />
                  </div>
                  <Card.Body className="oc-card-body d-flex flex-column">
                    <Card.Title className="oc-card-title">
                      {course.title}
                    </Card.Title>
                    <Card.Text className="oc-card-desc flex-grow-1">
                      {course.description}
                    </Card.Text>
                    <Button
                      className="oc-view-btn w-100 mt-3"
                      onClick={() => navigate(course.path)}
                    >
                      View Details
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
}

export default OurCourses;
